import styled from 'styled-components';
import React from 'react';
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import TileHeader from '../../components/TileHeader/TileHeader';
import { Toggle } from 'carbon-components-react';
const Analytics = () => {

  const [isGaToggle, setIsGaToggle] = React.useState(true);
  let url = ""
  let dataDogUrl = ""
  if(localStorage.getItem('client') === 'takeda'){
    url = "https://lookerstudio.google.com/embed/reporting/bd2c7dca-fc50-44cb-9623-1829f9b1e635/page/w436B"
    dataDogUrl = "https://p.datadoghq.com/sb/embed/31f5298e-17a0-11ef-b11e-da7ad0900002-ab99f859403c2f1a84a9888941bc0386"
  }
  if(localStorage.getItem('client') === 'alnylam'){
    url = "https://lookerstudio.google.com/embed/reporting/0ff520ff-1c57-496d-85f3-14abb9db5203/page/w436B"
    dataDogUrl = "https://p.datadoghq.com/sb/embed/31f5298e-17a0-11ef-b11e-da7ad0900002-08a267067d11066ef0e5b892d570dfb7"
  }
  if(localStorage.getItem('client') === 'biogen'){
    url = "https://lookerstudio.google.com/embed/reporting/0ff520ff-1c57-496d-85f3-14abb9db5203/page/w436B"
    dataDogUrl = "https://p.datadoghq.com/sb/embed/31f5298e-17a0-11ef-b11e-da7ad0900002-fbb77d1afb417df7e10bd7d91ea6aa58"
  }
  if(localStorage.getItem('client') === 'xogene' || localStorage.getItem('client') === 'public'){
    url = "https://lookerstudio.google.com/embed/reporting/b69d9a8b-2453-4f7e-89f6-9c9aacbdbc17/page/w436B"
    dataDogUrl = "https://p.datadoghq.com/sb/embed/31f5298e-17a0-11ef-b11e-da7ad0900002-2707e5b5e69f3006e5472bdb0b39b83a"
  }
  if(localStorage.getItem('client') === 'jnj'){
    url = "https://lookerstudio.google.com/embed/reporting/3f3262a6-4ff7-412a-86fb-54e18cbf9b87/page/w436B"
    dataDogUrl = "https://p.datadoghq.com/sb/embed/31f5298e-17a0-11ef-b11e-da7ad0900002-91ce2d72a1cd30018a22eacdbfbc1ce3"
  }
  // <iframe src="https://p.datadoghq.com/sb/embed/31f5298e-17a0-11ef-b11e-da7ad0900002-2707e5b5e69f3006e5472bdb0b39b83a" title="Dashboard Name" width="800" height="800"></iframe>

  return (
    <Container>
      <ContentContainer>

        <PageContent>

          <TileHeader 
            title="Analytics"
            size="lg"
          />
          <Toggle
							// id={``}
							labelA="Google Analytics"
							labelB="Advanced Analytics"
              onClick={() => {
                setIsGaToggle(!isGaToggle)
              }}
							// disabled={true}
						/>
           <iframe
                width="100%"
                height="950"
                src={isGaToggle ? url : dataDogUrl}
                frameBorder="0"
                sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
                allowFullScreen></iframe>
        </PageContent>

      </ContentContainer>
    </Container>
  );
};

export default Analytics;


const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: 40px;
`